import { List, Map, Record } from 'immutable';
import BusinessPartner from '~/data/BusinessPartner';
import type ErrorRecord from '~/data/ErrorRecord';
import InviteRequestCountryRecord from '~/data/InviteRequestCountryRecord';
import LanguageRecord from '~/data/LanguageRecord';
import EditInviteRequestFormRecord from './EditInviteRequestFormRecord';

const keys: Fields = {
  isLoading: false,
  isSaving: false,
  isSaved: false,
  countries: List(),
  languages: List(),
  defaultLanguage: Map<string, string>(),
  businessPartners: List(),
  formData: new EditInviteRequestFormRecord(),
  errors: undefined,
};

interface Fields {
  isLoading: boolean;
  isSaving: boolean;
  isSaved: boolean;
  countries: List<InviteRequestCountryRecord>;
  languages: List<LanguageRecord>;
  defaultLanguage: Map<string, string>;
  businessPartners: List<BusinessPartner>;
  formData: EditInviteRequestFormRecord;
  errors?: List<ErrorRecord>;
}

export default class EditInviteRequestRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);
    const newValues: Partial<Fields> = {};

    if (values) {
      if (values.countries) {
        newValues.countries = List(
          values.countries.map(
            (country) => new InviteRequestCountryRecord(country)
          )
        );
      }

      if (values.languages) {
        newValues.languages = List(
          values.languages.map((language) => new LanguageRecord(language))
        );
      }

      if (values.businessPartners) {
        newValues.businessPartners = List(
          values.businessPartners.map(
            (businessPartner) => new BusinessPartner(businessPartner)
          )
        );
      }
    }

    return this.merge(newValues);
  }
}
